import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "./components/theme/theme-provider";
import { SchoolProvider, CampusProvider } from "./contexts";
import { Toaster } from "sonner";
import { useAuthStore } from "./store/authStore";
import { router } from "./router";
import { useEffect, useState } from "react";
import { AxiosError } from "axios";

const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        onError: (error: unknown) => {
          console.log("[QueryClient] Query/Mutation error:", error);
          if (error instanceof AxiosError && error.response?.status === 401) {
            console.log("[QueryClient] 401 error detected, logging out");
            const { logout } = useAuthStore.getState();
            logout();
          }
        },
      },
    },
  });

function App() {
  const [queryClient] = useState(() => createQueryClient());
  const { isAuthenticated, checkAuth } = useAuthStore();

  console.log("[App] Initial render - isAuthenticated:", isAuthenticated);

  useEffect(() => {
    console.log("[App] useEffect running - checking authentication");
    const authResult = checkAuth();
    console.log("[App] checkAuth result:", authResult);
    console.log(
      "[App] isAuthenticated after checkAuth:",
      useAuthStore.getState().isAuthenticated
    );
  }, []); // checkAuth doesn't need to be in dependencies

  useEffect(() => {
    console.log("[App] Auth state changed - isAuthenticated:", isAuthenticated);
    if (!isAuthenticated) {
      console.log("[App] Not authenticated, clearing query client");
      queryClient.clear();
    }
  }, [isAuthenticated, queryClient]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <SchoolProvider>
          <CampusProvider>
            <RouterProvider router={router} />
            <Toaster richColors position="top-right" />
          </CampusProvider>
        </SchoolProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
